export const canonicalChannelsToChainList = [
  { channelId: 'channel-220', chainA: 'CosmosHub', chainB: 'Injective' },
  { channelId: 'channel-122', chainA: 'Osmosis', chainB: 'Injective' },
  { channelId: 'channel-17', chainA: 'Terra', chainB: 'Injective' },
  { channelId: 'channel-41', chainA: 'Persistence', chainB: 'Injective' },
  { channelId: 'channel-12', chainA: 'Chihuahua', chainB: 'Injective' },
  { channelId: 'channel-23', chainA: 'Secret Network', chainB: 'Injective' },
  { channelId: 'channel-59', chainA: 'Juno', chainB: 'Injective' },
  { channelId: 'channel-6', chainA: 'Stride', chainB: 'Injective' },
  { channelId: 'channel-90', chainA: 'Crescent', chainB: 'Injective' },
  { channelId: 'channel-1', chainA: 'Sommelier', chainB: 'Injective' },
  { channelId: 'channel-8', chainA: 'Canto', chainB: 'Injective' },
  { channelId: 'channel-91', chainA: 'Terra2', chainB: 'Injective' },
  { channelId: 'channel-92', chainA: 'Terra2', chainB: 'Injective' },
  { channelId: 'channel-3', chainA: 'Migaloo', chainB: 'Injective' },
  { channelId: 'channel-122', chainA: 'Kava', chainB: 'Injective' },
  { channelId: 'channel-146', chainA: 'Oraichain', chainB: 'Injective' },
  { channelId: 'channel-31', chainA: 'Noble', chainB: 'Injective' },
  { channelId: 'channel-7', chainA: 'Celestia', chainB: 'Injective' },
  { channelId: 'channel-54', chainA: 'Kujira', chainB: 'Injective' },
  { channelId: 'channel-13', chainA: 'Andromeda', chainB: 'Injective' },
  { channelId: 'channel-25', chainA: 'Saga', chainB: 'Injective' },
  { channelId: 'channel-33', chainA: 'fetchhub-4', chainB: 'Injective' },
  { channelId: 'channel-2', chainA: 'mantrachain', chainB: 'Injective' },
  { channelId: 'channel-4', chainA: 'xion-mainnet-1', chainB: 'Injective' },
  { channelId: 'channel-1', chainA: 'Injective', chainB: 'CosmosHub' },
  { channelId: 'channel-83', chainA: 'Injective', chainB: 'Evmos' },
  { channelId: 'channel-8', chainA: 'Injective', chainB: 'Osmosis' },
  { channelId: 'channel-4', chainA: 'Injective', chainB: 'Terra' },
  { channelId: 'channel-84', chainA: 'Injective', chainB: 'Axelar' },
  { channelId: 'channel-82', chainA: 'Injective', chainB: 'Persistence' },
  { channelId: 'channel-76', chainA: 'Injective', chainB: 'Chihuahua' },
  { channelId: 'channel-88', chainA: 'Injective', chainB: 'Secret Network' },
  { channelId: 'channel-78', chainA: 'Injective', chainB: 'Juno' },
  { channelId: 'channel-89', chainA: 'Injective', chainB: 'Stride' },
  { channelId: 'channel-23', chainA: 'Injective', chainB: 'Crescent' },
  { channelId: 'channel-13', chainA: 'Injective', chainB: '' },
  { channelId: 'channel-93', chainA: 'Injective', chainB: 'Sommelier' },
  { channelId: 'channel-98', chainA: 'Injective', chainB: 'Kujira' },
  { channelId: 'channel-99', chainA: 'Injective', chainB: 'Canto' },
  { channelId: 'channel-102', chainA: 'Injective', chainB: 'Migaloo' },
  { channelId: 'channel-104', chainA: 'Injective', chainB: 'Terra2' },
  { channelId: 'channel-105', chainA: 'Injective', chainB: 'Terra2' },
  { channelId: 'channel-138', chainA: 'Injective', chainB: 'Nois' },
  { channelId: 'channel-140', chainA: 'Injective', chainB: 'Nois' },
  { channelId: 'channel-143', chainA: 'Injective', chainB: 'Kava' },
  { channelId: 'channel-147', chainA: 'Injective', chainB: 'Oraichain' },
  { channelId: 'channel-148', chainA: 'Injective', chainB: 'Noble' },
  { channelId: 'channel-152', chainA: 'Injective', chainB: 'Celestia' },
  { channelId: 'channel-183', chainA: 'Injective', chainB: 'Gateway' },
  { channelId: 'channel-213', chainA: 'Injective', chainB: 'Andromeda' },
  { channelId: 'channel-261', chainA: 'Injective', chainB: 'Saga' },
  { channelId: 'channel-283', chainA: 'Injective', chainB: 'fetchhub-4' },
  { channelId: 'channel-363', chainA: 'Injective', chainB: 'mantrachain' },
  { channelId: 'channel-387', chainA: 'Injective', chainB: 'xion-mainnet-1' }
]

export const canonicalChannelIds = [
  'channel-1',
  'channel-4',
  'channel-5',
  'channel-6',
  'channel-8',
  'channel-13',
  'channel-74',
  'channel-76',
  'channel-78',
  'channel-82',
  'channel-83',
  'channel-84',
  'channel-88',
  'channel-89',
  'channel-90',
  'channel-93',
  'channel-98',
  'channel-99',
  'channel-102',
  'channel-104',
  'channel-105',
  'channel-138',
  'channel-140',
  'channel-143',
  'channel-147',
  'channel-148',
  'channel-152',
  'channel-183',
  'channel-213',
  'channel-261',
  'channel-283',
  'channel-363',
  'channel-387'
]
